import { defineMessages } from 'react-intl';

const scope = 'app.builder.Knowledge.components.TreeView';

export default defineMessages({
  competencyDocumentLearningObjectiveSingular: {
    id: `${scope}.competency.document.learning.objective.singular`,
    defaultMessage: 'Learning Objective',
  },
  competencyDocumentLearningObjectivesPlural: {
    id: `${scope}.competency.document.learning.objectives.plural`,
    defaultMessage: 'Learning Objectives',
  },
  competencyDocumentTotalObjectiveSingular: {
    id: `${scope}.competency.document.Total.objective.singular`,
    defaultMessage: 'Total Objective',
  },
  competencyDocumentTotalObjectivesPlural: {
    id: `${scope}.competency.document.Total.objectives.plural`,
    defaultMessage: 'Total Objectives',
  },
  duplicateItem: {
    id: `${scope}.duplicateItem`,
    defaultMessage: 'Duplicate',
  },
  parentItemTitle: {
    id: `${scope}.parentItemTitle`,
    defaultMessage: 'New LO',
  },
  childItemTitle: {
    id: `${scope}.childItemTitle`,
    defaultMessage: 'New EO',
  },
  deleteItem: {
    id: `${scope}.deleteItem`,
    defaultMessage: 'Delete',
  },
});
